module.exports = __webpack_public_path__ + "img/01.f0c9f14c.png";